__turbopack_context__.v({
  "checkboxSmall": "_5UvZ9G_checkboxSmall",
  "disclaimerContainer": "_5UvZ9G_disclaimerContainer",
  "disclaimerContent": "_5UvZ9G_disclaimerContent",
  "disclaimerText": "_5UvZ9G_disclaimerText",
  "inputError": "_5UvZ9G_inputError",
  "privacyStatementLink": "_5UvZ9G_privacyStatementLink",
});
